const updates = [
  {
    date: '2026-07-30',
    tag: '新片上线',
    title: '《流浪地球3》高清完整版已上线',
    desc: '国产科幻巨制第三部高清完整版已更新，全片无删减，欢迎在线观看。',
  },
  {
    date: '2026-07-29',
    tag: '剧集更新',
    title: '《庆余年3》最新三集同步更新',
    desc: '热门古装权谋剧《庆余年3》今日更新至第18集，剧情进入高潮阶段。',
  },
  {
    date: '2026-07-28',
    tag: '片源新增',
    title: '久久视频专区新增150部经典港片',
    desc: '周星驰、成龙、周润发等经典港片全集上线，高清修复版重温黄金年代。',
  },
  {
    date: '2026-07-27',
    tag: '系统优化',
    title: '全站CDN节点升级完成，播放更流畅',
    desc: '新增华南、西南两个加速节点，覆盖全国主要地区，缓冲速度提升40%。',
  },
  {
    date: '2026-07-26',
    tag: '综艺上线',
    title: '芒果视频热门综艺专场更新',
    desc: '《乘风破浪》《披荆斩棘》《明星大侦探》等热门综艺最新季全集上线。',
  },
  {
    date: '2026-07-25',
    tag: '片单推荐',
    title: '暑假必看影视片单新鲜出炉',
    desc: '编辑团队精选50部适合假期观看的电影和电视剧，涵盖动作、喜剧、动画。',
  },
  {
    date: '2026-07-24',
    tag: '日剧上线',
    title: '丝瓜视频日剧频道重磅更新',
    desc: '《重启人生》《弥留之国的爱丽丝》等高分日剧全集上线，中文字幕同步。',
  },
  {
    date: '2026-07-23',
    tag: '97视频',
    title: '97视频经典老剧修复版上线',
    desc: '《还珠格格》《新白娘子传奇》等童年经典高清修复版已更新，怀旧必看。',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-white">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时了解苹果视频的最新资源和更新信息
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-background-200">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-white"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap pt-0.5">
                    {item.date}
                  </span>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 font-serif">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 mt-1">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}